import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BsrMobileComponent } from './bsr-mobile/bsr-mobile.component';

const routes: Routes = [

  {// BSR-Mobile https://mynamepage.com/te2687
   path: ':id',
  component: BsrMobileComponent
 },
  {
    path: '',
    redirectTo: '/',
    pathMatch: 'full'
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }


